/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IPageHeaderViewProps } from './page-header';

export default (props: IPageHeaderViewProps) => {
    const { image, title, subtitle } = props;
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                data-enable-parallax='0'
                data-parallax-speed='0.5'
                data-background-images={''}
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src=''
                data-element='inner'
                style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    textAlign: 'center',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <figure
                    data-content-type='image'
                    data-appearance='full-width'
                    data-element='main'
                    style={{ margin: 'auto', padding: '0px', borderStyle: 'none' }}
                >
                    <img
                        className='pagebuilder-mobile-hidden'
                        src={image?.src}
                        alt={image?.altText}
                        title=''
                        data-element='desktop_image'
                        style={{
                            borderStyle: 'none',
                            borderWidth: '1px',
                            borderRadius: '0px',
                            maxWidth: '100%',
                            height: 'auto'
                        }}
                    />
                    <img
                        className='pagebuilder-mobile-only'
                        src={image?.src}
                        alt={image?.altText}
                        title=''
                        data-element='mobile_image'
                        style={{
                            borderStyle: 'none',
                            borderWidth: '1px',
                            borderRadius: '0px',
                            maxWidth: '100%',
                            height: 'auto'
                        }}
                    />
                </figure>
                <h1
                    data-content-type='heading'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', lineHeight: '1.2' }}
                >
                    {title}
                </h1>
                <h3
                    data-content-type='heading'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', lineHeight: '1' }}
                >
                    {subtitle}
                </h3>
            </div>
        </div>
    );
};
